module.exports = __webpack_public_path__ + "static/img/daiyunying_08.61a04a29.jpg";